//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapState, mapActions } from "vuex";
import router from "../../../router";

export default {
  props: {
    article: {},
  },

  data() {
    return {
      columns: [
        {
          name: "orderDate",
          align: "left",
          label: this.$t("order.orderDate"),
          field: "orderDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "orderNumber",
          align: "left",
          label: this.$t("order.orderNo"),
          field: "orderNumber",
          sortable: true,
        },
        {
          name: "supplierName",
          align: "left",
          label: this.$t("products.supplier"),
          field: "supplierName",
          sortable: true,
        },
        {
          name: "recievedDate",
          align: "left",
          label: "Mottatt dato",
          field: "recievedDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "numberOfItems",
          align: "right",
          label: this.$t("order.quantity"),
          field: "numberOfItems",
          sortable: true,
        },
        {
          name: "numberOfReceivedOrPicked",
          align: "right",
          label: this.$t("purchaseOrder.recieved"),
          field: "numberOfReceivedOrPicked",
          sortable: true,
        },
      ],

      dense: true,
      orderItems: [],
      hideTableBottom: true,
      totalValue: 0,
      totalReceived: 0,
    };
  },

  async mounted() {
    await this.refresh();
  },

  computed: {
    ...mapState("main", []),
  },

  methods: {
    ...mapActions("main", ["getPurchaseOrderItemsByProductAndPeriod"]),

    async refresh() {
      if (!this.article.fromDate || !this.article.toDate) {
        let dateEnd = new Date();
        this.article.toDate = date.formatDate(dateEnd, "DD-MM-YYYY");
        let dateStart = date.subtractFromDate(dateEnd, { month: 3 });
        this.article.fromDate = date.formatDate(dateStart, "DD-MM-YYYY");
      }
      this.getPurchaseOrderItems();
    },

    async getPurchaseOrderItems() {
      if (this.article.fromDate && this.article.toDate) {
        this.orderItems = await this.getPurchaseOrderItemsByProductAndPeriod({
          productId: this.article.id,
          fromDate: this.toEngFormat(this.article.fromDate),
          toDate: this.toEngFormat(this.article.toDate),
        });
        this.calculateTotalSum();
      } else {
        this.orderItems = [];
        this.totalValue = 0;
        this.totalReceived = 0;
      }
    },

    calculateTotalSum() {
      this.totalValue = 0;
      this.totalReceived = 0;
      for (var i = 0; i < this.orderItems.length; i++) {
        this.totalValue += this.orderItems[i].numberOfItems;
        this.totalReceived += this.orderItems[i].numberOfReceivedOrPicked;
      }
    },

    openPurchaseOrder(orderId) {
      if (this.isRecevingMode) {
        router.push({ name: "PurchaseReceive", params: { id: orderId } });
      } else {
        router.push({ name: "Purchase", params: { id: orderId } });
      }
    },

    async hideFromDate(pdate) {
      pdate.hide();
      this.fromDateChanged();
    },

    async hideToDate(pdate) {
      pdate.hide();
      this.toDateChanged();
    },

    async fromDateChanged() {
      this.article.fromDate = this.autoCompleteDate(this.article.fromDate);
      this.getPurchaseOrderItems();
    },

    async toDateChanged() {
      this.article.toDate = this.autoCompleteDate(this.article.toDate);
      this.getPurchaseOrderItems();
    },

    toEngFormat(strDate) {
      var splitDate = strDate.split("-");
      return splitDate[2] + "-" + splitDate[1] + "-" + splitDate[0];
    },

    autoCompleteDate(strDate) {
      if (strDate.length > 0 && strDate.length < 7) {
        if (isNaN(parseInt(strDate))) return "";
        try {
          if (strDate.length < 6) {
            let today = new Date();
            if (strDate.length == 1)
              strDate = "0" + strDate + date.formatDate(today, "MMYY");
            else if (strDate.length == 2)
              strDate = strDate + date.formatDate(today, "MMYY");
            else if (strDate.length == 3) {
              strDate = strDate.substring(0, 2) + "0" + strDate.substring(2, 3);
              strDate = strDate + date.formatDate(today, "YY");
            } else if (strDate.length == 4)
              strDate = strDate + date.formatDate(today, "YY");
            else if (strDate.length == 5) {
              strDate = strDate.substring(0, 4);
              strDate = strDate + date.formatDate(today, "YY");
            }
          }

          let newDate = date.extractDate(strDate, "DDMMYY");
          return date.formatDate(newDate, "DD-MM-YYYY");
        } catch (error) {
          return "";
        }
      }
      return strDate;
    },
  },
};
